import React from 'react';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { useSession } from '@/state/Session';
import { SUPER_ADMIN, GROUP_ADMIN, MONITORING } from '@/components/entities/role/enums';

const ADMIN_ROLES = [SUPER_ADMIN, GROUP_ADMIN, MONITORING];

const GoRedirect: React.FC<RouteComponentProps> = ({ location }) => {
  const sessionCtx = useSession();
  const session = sessionCtx?.session;

  const params = new URLSearchParams(location.search);
  const to = params.get('to');
  const orgId = params.get('orgId');

  if (!to) {
    return <Redirect to="/" />;
  }

  // Forward all query params except 'to' and 'orgId' to the target path
  params.delete('to');
  params.delete('orgId');
  const remaining = params.toString();
  const targetQuery = remaining ? `?${remaining}` : '';

  const isAdmin =
    session?.user?.metadata &&
    Array.isArray(session.user.metadata) &&
    session.user.metadata.some((role: string) => ADMIN_ROLES.includes(role));

  const prefix = isAdmin && orgId ? `/su/${orgId}` : '';

  return <Redirect to={`${prefix}${to}${targetQuery}`} />;
};

export default withRouter(GoRedirect);
